import React from 'react'

import vector_right from '../../../../images/basic/header/vector_right.svg'

import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import circle_green from "../../../../images/main/greenIcon.svg";
import circle from "../../../../images/main/curcle.svg";

const InterShipsVolginsky = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <div>
            <p className={styles.title}>Вольгинский</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
            <p className={styles.title}>Живи и учись <br/>в научной среде</p>
          </div>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.left}>
          <div>
            <div className={styles.list_scroll_box}>
              <div className={styles.list_wrapper}>
              </div>
            </div>
          </div>
          <div>
              <div className={styles.down_side}>
                <p>
                  Сотрудники Generium в Вольгинском отвечают за разработку и производство препаратов. Здесь же работают
                  отделы контроля качества и логистики.
                </p>
                <Link className={styles.button} to='/relocation'>
                  Узнать о жизни в поселке{' '}
                  <img className={styles.vector_right} src={vector_right} alt='vector' draggable='false' />
                </Link>
              </div>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
              <div className={styles.rightSide_iframe}>
                <iframe
                  src='https://vk.com/video_ext.php?oid=-221108214&id=456239039&hash=819aa917002d46a4'
                  title='VK video player'
                  allow='autoplay; encrypted-media; fullscreen; picture-in-picture'
                  frameborder="0"
                  allowfullscreen="1"
                />
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InterShipsVolginsky
